(function(){var e=jQuery,f="jQuery.pause",d=1,b=e.fn.animate,a={};function c(){return new Date().getTime()}e.fn.animate=function(k,h,j,i){var g=e.speed(h,j,i);g.complete=g.old;return this.each(function(){if(!this[f]){this[f]=d++}var l=e.extend({},g);b.apply(e(this),[k,e.extend({},l)]);a[this[f]]={run:true,prop:k,opt:l,start:c(),done:0}})};e.fn.pause=function(){return this.each(function(){if(!this[f]){this[f]=d++}var g=a[this[f]];if(g&&g.run){g.done+=c()-g.start;if(g.done>g.opt.duration){delete a[this[f]]}else{e(this).stop();g.run=false}}})};e.fn.resume=function(){return this.each(function(){if(!this[f]){this[f]=d++}var g=a[this[f]];if(g&&!g.run){g.opt.duration-=g.done;g.done=0;g.run=true;g.start=c();b.apply(e(this),[g.prop,e.extend({},g.opt)])}})}})();

function Infographic () {
    this.wrapper    = jQuery('.infographic');
    this.slider     = this.wrapper.children('ul');
    this.sliderWidth = 0;
    this.pagination = jQuery('.infographic-pagination');
    this.distanceLeft = 100;
    this.distanceLeftOverflow = -100;
    this.distanceTop = 150;
    this.distanceBottom = 400;
    this.positions = [];
    this.numberOfPoints = this.slider.children('li').length;
    this.maxPointsPerPage = 8;
    this.pages = 1;
    this.moving = false;
    this.moveSpeed = 3000;
    this.lineIntervall = null;
    this.screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
}

Infographic.prototype = {
    constructor: Infographic,

    /**
     * Startet die Funktion
     *
     */
    init: function () {
        if (this.screenWidth <= 991 && this.screenWidth > 870) {
            this.maxPointsPerPage = 4;
        } else if (this.screenWidth <= 870 && this.screenWidth > 768) {
            this.maxPointsPerPage = 3;
            this.distanceLeft = 200;
        } else if (this.screenWidth <= 768 && this.screenWidth > 450) {
            this.maxPointsPerPage = 2;
            this.distanceLeft =  150;
        } else if (this.screenWidth <= 450) {
            this.maxPointsPerPage = 1;
            this.distanceLeft = 50;
        }

        this.removeLines();
        this.addEvents();
        this.draw();
        this.setPagination();


        /**
         * Auto-Move
         */
        //this.sliderHoverd = true;
        //this.startMove();
    },

    /**
     * Diese Methode sollte aufgerufen werden wenn z.B. die Bildschirmgröße geändert wurde
     * und eine neue Initailisierung nötig ist
     *
     */
    removeLines: function () {
        //this.wrapper.children('.line').remove();
        this.wrapper.children('.lines').children('.line').remove();
    },

    /**
     * Funktion des Scroll-Events
     *
     * @param $orientation
     */
    scrollTo: function ($orientation) {
        var _this = this,
            x = '+=';

        if ($orientation == 'left') {
            x = '-=';
        }

        var scrollLeft = 0;
        var currentScrollLeft = this.wrapper.scrollLeft();
        console.log(currentScrollLeft + ' ; ' + this.wrapper.width());

        if ($orientation == 'left') {
            scrollLeft = currentScrollLeft - this.wrapper.width();
        } else {
            scrollLeft = currentScrollLeft + this.wrapper.width();
        }

        this.wrapper.animate({
            scrollLeft: scrollLeft
        }, 500, function () {
            // Pagination ausblenden wenn ganz am Ende
            if (_this.wrapper.width() <= _this.wrapper.scrollLeft()) {
                _this.pagination.children('.right').addClass('hidden');
            } else {
                _this.pagination.children('.right').removeClass('hidden');
            }

            if (_this.wrapper.scrollLeft() <= 0) {
                _this.pagination.children('.left').addClass('hidden');
            } else {
                _this.pagination.children('.left').removeClass('hidden');
            }
        });



        /*this.wrapper.animate({
            scrollLeft: x + this.wrapper.width()
        }, 500);*/
    },

    /**
     * Setzt die Navigations-Pfeile an die richtige Stelle
     *
     */
    setPagination: function () {
        if (this.pagination.length) {
            this.pagination.children('div').css({
                top: this.wrapper.position().top + 'px'
            });

            this.pagination.children('.left').css({
                left: '30px'
            });

            this.pagination.children('.right').css({
                right: '30px'
            });


            // Pagination ausblenden wenn scrollen nicht notwendig
            if (this.numberOfPoints <= this.maxPointsPerPage) {
                this.pagination.children('.left').css({
                    visibility: 'hidden'
                });
                this.pagination.children('.right').css({
                    visibility: 'hidden'
                });
            } else {
                this.pagination.children('.left').css({
                    visibility: 'visible'
                });
                this.pagination.children('.right').css({
                    visibility: 'visible'
                });
            }

            if (this.wrapper.scrollLeft() <= 0) {
                this.pagination.children('.left').addClass('hidden');
            } else {
                this.pagination.children('.left').removeClass('hidden');
            }
        }
    },

    /**
     * Fügt Click-Events zum Steuern der Navigation hinzu
     *
     */
    addEvents: function () {
        var _this = this;

        this.pagination.children('.right').on('click', function () {
            _this.scrollTo('right');
        });
        this.pagination.children('.left').on('click', function () {
            _this.scrollTo('left');
        });


        this.slider.children('li').mouseenter(function () {
            var index = jQuery(this).index();

            _this.sliderHoverd = false;
            _this.stopMove();

            jQuery(this).children('.circle').addClass('hover');
            jQuery(this).children('.description').addClass('hover');
            jQuery(this).children('img').addClass('hover');
            _this.wrapper.children('.lines').children('.line:nth-child(' + (index + 1) + ')').addClass('hover');
            _this.wrapper.children('.lines').children('.line:nth-child(' + (index + 2) + ')').addClass('hover-second');
        });
        this.slider.children('li').mouseleave(function () {
            var index = jQuery(this).index();

            _this.sliderHoverd = true;
            _this.startMove();

            jQuery(this).children('.circle').removeClass('hover');
            jQuery(this).children('.description').removeClass('hover');
            jQuery(this).children('img').removeClass('hover');
            _this.wrapper.children('.lines').children('.line:nth-child(' + (index + 1) + ')').removeClass('hover');
            _this.wrapper.children('.lines').children('.line:nth-child(' + (index + 2) + ')').removeClass('hover-second');
        });

        this.wrapper.hover(function () {
            _this.setPagination();
        });

        /*this.wrapper.mouseenter(function () {
            _this.sliderHoverd = true;
            _this.startMove();
        });
        this.wrapper.mouseleave(function () {
            _this.sliderHoverd = false;
            _this.stopMove();
        });*/

        /*jQuery(document).mousemove(function(e) {
            var left = 0,
                top = 0;

            if (_this.sliderHoverd) {
                if (e.pageX > _this.mousePos.x) {
                    _this.slider.stop();
                    _this.wrapper.children('.lines').stop();

                    left = (e.pageX - _this.mousePos.x) > 10 ? 10 : (e.pageX - _this.mousePos.x);

                    if (_this.slider.position().left - left > -200) {
                        _this.slider.animate({
                            left: '-=' + left + 'px'
                        }, 0);
                        _this.wrapper.children('.lines').animate({
                            left: '-=' + left + 'px'
                        }, 0);
                    }
                } else if (e.pageX < _this.mousePos.x) {
                    _this.slider.stop();
                    _this.wrapper.children('.lines').stop();

                    left = (_this.mousePos.x - e.pageX) > 10 ? 10 : (_this.mousePos.x - e.pageX);

                    if (_this.slider.position().left + left < 200) {
                        _this.slider.animate({
                            left: '+=' + left + 'px'
                        }, 0);
                        _this.wrapper.children('.lines').animate({
                            left: '+=' + left + 'px'
                        }, 0);
                    }
                }

                if (e.pageY > _this.mousePos.y) {
                    _this.slider.stop();
                    _this.wrapper.children('.lines').stop();

                    top = (e.pageY - _this.mousePos.y) > 5 ? 5 : (e.pageY - _this.mousePos.y);

                    if (_this.slider.position().top - top > -25) {
                        _this.slider.animate({
                            top: '-=' + top + 'px'
                        }, 0);
                        _this.wrapper.children('.lines').animate({
                            top: '-=' + top + 'px'
                        }, 0);
                    }
                } else if (e.pageY < _this.mousePos.y) {
                    _this.slider.stop();
                    _this.wrapper.children('.lines').stop();

                    top = (_this.mousePos.y - e.pageY) > 5 ? 5 : (_this.mousePos.y - e.pageY);

                    if (_this.slider.position().top + top < 25) {
                        _this.slider.animate({
                            top: '+=' + top + 'px'
                        }, 0);
                        _this.wrapper.children('.lines').animate({
                            top: '+=' + top + 'px'
                        }, 0);
                    }
                }
            }

            _this.setCurrentMousePos(e.pageX, e.pageY);
        });*/
    },

    /**
     * Setzt die aktuelle Mausposition
     *
     */
    setCurrentMousePos: function (x, y) {
        this.mousePos = {
            'x': x,
            'y': y
        };
    },

    /**
     * Berechnet die Anzahl an benötigter Seiten
     *
     */
    calculatePageEntrys: function () {
        this.pages = Math.ceil (this.numberOfPoints / this.maxPointsPerPage)
    },

    /**
     * Anhand der benötigten Seiten sowie der Wrapper-Breite wird die Gesamtbreite der Grafik ermittelt
     *
     */
    setSliderWidth: function () {
        this.sliderWidth = (this.wrapper.width() * this.pages);

        this.slider.css({
            width: this.sliderWidth + 'px'
        });
    },

    /**
     * Berechnet den Abstand zwischen den einzelnen Punkten
     *
     */
    setDistanceLeft: function () {
        this.distanceLeft = this.wrapper.width() / (this.maxPointsPerPage + 1);
    },

    /**
     * Setzt die Verbindungslinien ein und setzt die Punkte per Zufall
     *
     */
    draw: function () {
        var _this = this;

        if (this.numberOfPoints < this.maxPointsPerPage) {
            this.maxPointsPerPage = this.numberOfPoints;
        }

        this.calculatePageEntrys();
        this.setSliderWidth();
        this.setDistanceLeft();

        /**
         * Setzt die Punkte
         */
        var leftOverflow = 0;

        this.slider.children('li').each(function (index) {
            var key = (index+1),
                left = _this.distanceLeft * key,
                top,
                bottom;

            if (_this.screenWidth < 450) {
                left -= 60;
            }


            if (index == (_this.maxPointsPerPage) ||
                index == (_this.maxPointsPerPage*2) ||
                index == (_this.maxPointsPerPage*3) ||
                index == (_this.maxPointsPerPage*4) ||
                index == (_this.maxPointsPerPage*5) ||
                index == (_this.maxPointsPerPage*6) ||
                index == (_this.maxPointsPerPage*7) ||
                index == (_this.maxPointsPerPage*8) ||
                index == (_this.maxPointsPerPage*9) ||
                index == (_this.maxPointsPerPage*10) ||
                index == (_this.maxPointsPerPage*11) ||
                index == (_this.maxPointsPerPage*12) ||
                index == (_this.maxPointsPerPage*13) ||
                index == (_this.maxPointsPerPage*14) ||
                index == (_this.maxPointsPerPage*15)) {

                _this.distanceLeftOverflow += _this.distanceLeft;
            }

            // Variable Positionierung
            //bottom = _this.getRandomInt((_this.distanceBottom - 60), (_this.distanceBottom + 60));
            //top = _this.getRandomInt((_this.distanceTop - 60), (_this.distanceTop + 60));

            bottom = (_this.distanceBottom - 60);
            top = (_this.distanceTop - 60);

            if (index == 0) {
                bottom = (_this.distanceBottom - 10);
                top = (_this.distanceTop + 25);
            }
            if (index == 1) {
                bottom = (_this.distanceBottom - 80);
                top = (_this.distanceTop - 14);
            }
            if (index == 2) {
                bottom = (_this.distanceBottom - 22);
                top = (_this.distanceTop - 31);
            }
            if (index == 3) {
                bottom = (_this.distanceBottom - 180);
                top = (_this.distanceTop - 80);
            }
            if (index == 4) {
                bottom = (_this.distanceBottom - 17);
                top = (_this.distanceTop + 15);
            }
            if (index == 5) {
                bottom = (_this.distanceBottom - 15);
                top = (_this.distanceTop - 42);
            }
            if (index == 6) {
                bottom = (_this.distanceBottom - 40);
                top = (_this.distanceTop - 30);
            }
            if (index == 7) {
                bottom = (_this.distanceBottom - 100);
                top = (_this.distanceTop - 14);
            }


            if (_this.screenWidth > 450) {
                if (leftOverflow > 0) {
                    left -= leftOverflow;
                    leftOverflow = 0;
                } else if (leftOverflow < 0) {
                    left += leftOverflow;
                    leftOverflow = 0;
                } else {
                    //dynamicLeft = _this.getRandomInt((left - 80), (left + 80));

                    if (index == 0) dynamicLeft = (left - 22);
                    if (index == 1) dynamicLeft = (left + 42);
                    if (index == 2) dynamicLeft = (left - 33);
                    if (index == 3) dynamicLeft = (left - 20);
                    if (index == 4) dynamicLeft = (left + 30);
                    if (index == 5) dynamicLeft = (left + 50);
                    if (index == 6) dynamicLeft = (left - 0);
                    if (index == 7) dynamicLeft = (left - 80);

                    if (dynamicLeft > left) {
                        leftOverflow = dynamicLeft - left;
                    } else if (dynamicLeft < left) {
                        leftOverflow = left - dynamicLeft;
                    }
                }
            }

            _this.positions.push({
                left: left + _this.distanceLeftOverflow,
                top: ((key%2) == 0 ? bottom : top)
            });

            jQuery(this).css({
                left: _this.positions[_this.positions.length-1].left,
                top: _this.positions[_this.positions.length-1].top
            }).addClass((key%2) == 0 ? 'bottom-point' : 'top-point')
                .attr('data-top', _this.positions[_this.positions.length-1].top)
                .attr('data-left', _this.positions[_this.positions.length-1].left);

            jQuery(this).children('.description').css({
                width: (_this.distanceLeft + 120) + 'px'
            });

        }).promise().done(function () {
            /**
             * Fügt die Verbindungslinien ein
             */
            _this.preDrawLine(0, 1);

            _this.slider.children('li').each(function (index) {
                var key = (index+1);


                // Description Ausrichtung
                if (jQuery(this).hasClass('bottom-point')) {
                    var height = jQuery(this).children('.description').height();

                    jQuery(this).children('.description').css({
                        top: '-' + height + 'px'
                    });
                }


                _this.preDrawLine (key, (key+1));
            }).promise().done(function () {
                /*setInterval(function () {
                    _this.wrapper.children('.lines').html('');
                    _this.preDrawLine(0, 1);

                    _this.slider.children('li').each(function (index) {
                        var key = (index+1);

                        _this.preDrawLine (key, (key+1));
                    });
                }, 0);*/
            });

        });
    },

    /**
     * Bereitet das Zeichnen der Linie vor
     *
     * @param currentPointIndex [nth-child number of li point]
     * @param nextPointIndex [nth-child number of li point]
     */
    preDrawLine: function (currentPointIndex, nextPointIndex, action, lineNumber) {
        var currentPoint = '',
            nextPoint    = '';

        if (action == 'move') {
            if (currentPointIndex != 0) {
                currentPoint = currentPointIndex;
            }
        } else {
            if (this.slider.children('li:nth-child(' + currentPointIndex + ')').length) {
                //currentPoint = this.slider.children('li:nth-child(' + currentPointIndex + ')').children('.circle');
                currentPoint = this.slider.children('li:nth-child(' + currentPointIndex + ')');
            }
        }


        if (action == 'move') {
            nextPoint = nextPointIndex;
        } else {
            if (this.slider.children('li:nth-child(' + nextPointIndex + ')').length) {
                //nextPoint = this.slider.children('li:nth-child(' + nextPointIndex + ')').children('.circle');
                nextPoint = this.slider.children('li:nth-child(' + nextPointIndex + ')');
            }
        }

        this.drawLine(currentPoint, nextPoint, action, lineNumber);
    },

    /**
     * Zeichnet die berechnete Linie
     *
     * @param cPoint
     * @param nPoint
     *
     */
    drawLine: function (cPoint, nPoint, action, lineNumber) {
        var cOffset,
            nOffset,
            lineHeight = 2,
            _this = this;


        if (cPoint == '') {
            cOffset = {
                top: (this.wrapper.height() / 2),
                left: this.wrapper.offset().left,
                width: this.wrapper.width() || this.wrapper.offsetWidth,
                height: this.wrapper.height() || his.wrapper.offsetHeight
            }
        } else {
            cOffset = this.getOffset(cPoint);

        }

        if (nPoint == '') {
            nOffset = {
                top: (this.wrapper.height() / 16),
                left: this.wrapper.offset().left + (this.wrapper.children('ul').width()),
                width: this.wrapper.width(),
                height: this.wrapper.height()
            }
        } else {
            nOffset = this.getOffset(nPoint);
        }


        var x1, y1;

        if (cPoint == '') {
            x1 = cOffset.left;
            y1 = cOffset.top;
        } else {
            x1 = cOffset.left + 60 + 15;
            y1 = cOffset.top + 45 + 15;
        }


        var x2, y2;

        if (cPoint == '') {
            x2 = nOffset.left + 60 +15;
            y2 = nOffset.top + 45 + 15;
        } else {
            x2 = nOffset.left + 60 + 15;
            y2 = nOffset.top + 45 + 15;
        }

        if (nPoint == '') {
            x2 = x2 - 15;
        }


        // distance
        var length = Math.sqrt(((x2-x1) * (x2-x1)) + ((y2-y1) * (y2-y1)));
        // center
        var cx = ((x1 + x2) / 2) - (length / 2);
        var cy = ((y1 + y2) / 2) - (lineHeight / 2);
        var angle = Math.atan2((y1-y2),(x1-x2))*(180/Math.PI);


        var lineInner = "style='" +
            "left:" + cx + "px; " +
            "top:" + cy + "px; " +
            "width:" + length + "px; " +
            "-moz-transform:rotate(" + angle + "deg); " +
            "-webkit-transform:rotate(" + angle + "deg); " +
            "-o-transform:rotate(" + angle + "deg); " +
            "-ms-transform:rotate(" + angle + "deg); " +
            "transform:rotate(" + angle + "deg);'";

        this.wrapper.children('.lines').append(
            "<div class='line' " +
            lineInner +
            " />"
        );
    },

    /**
     * Animiert die Grafik
     *
     */
    move: function () {
        var _this = this;

        _this.slider.children('li').each(function (index) {


            var top = jQuery(this).data('top'),
                left = jQuery(this).data('left'),
                circle = jQuery(this).children('.circle');

            top = _this.getRandomInt((top - 20), (top + 20));
            left = _this.getRandomInt((left - 20), (left + 20));

            jQuery(this).attr('data-top-next', top);
            jQuery(this).attr('data-left-next', left);

            jQuery(this).animate({
                top: top,
                left: left
            }, _this.moveSpeed);

        }).promise().done(function () {
            if (_this.moving == true) {
                _this.move();
            }
        });
    },

    moveLines: function () {
        var _this = this;

        this.lineIntervall = setInterval(function () {
            _this.wrapper.children('.lines').html('');
            _this.preDrawLine(0, 1);

            _this.slider.children('li').each(function (index) {
                var key = (index+1);

                _this.preDrawLine (key, (key+1));
            });
        }, 0);
    },

    /**
     * Startet die Animation
     *
     */
    startMove: function () {
        //this.pagination.show();

        /*this.moving = true;
        this.moveLines();
        this.move();*/
    },

    /**
     * Stopt die Animation
     *
     */
    stopMove: function () {
        //this.pagination.hide();

        /*this.moving = false;
        window.clearInterval(this.lineIntervall);
        this.slider.children('li').pause();
        this.wrapper.children('.lines').children('.line').pause();*/
    },

    /**
     * Berechnet die Werte für einen Punkt
     *
     * @param el
     * @returns {{top: *, left: *, width: (*|number), height: (*|number)}}
     */
    getOffset: function (el) {
        return {
            top: el.position().top + el.parent().position().top,
            left: el.position().left + el.parent().position().left,
            width: el.width() || el.offsetWidth,
            height: el.height() || el.offsetHeight
        };
    },

    getRandomInt: function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
};


jQuery(document).ready(function () {
    if (jQuery('.infographic').length) {
        var info = new Infographic();
        info.init();
    }

    jQuery('.headerpics').flexslider({
        animation: "fade",
        fadeFirstSlide: false
    });

    jQuery('.infographic-mobile').flexslider({
        animation: "slide",
        controlNav: false,
        directionNav: false,
        touch: true
    });

    jQuery('.left-nav').on('click', function(){
        jQuery('.infographic-mobile').flexslider('prev');
        return false;
    });
    jQuery('.right-nav').on('click', function(){
        jQuery('.infographic-mobile').flexslider('next');
        return false;
    });

    if (jQuery('.quotes').length) {
        jQuery('.quote-text').children('p:first-child').prepend('&bdquo;');
        jQuery('.quote-text').children('p:last-child').append('&ldquo;');

        jQuery('.quotes').flexslider({
            animation: "slide",
            slideshowSpeed: 13000
        });
    }

    initSite();

    /*/!**
     * Klick-Event Methode
     *!/
    jQuery('.methode-item').hover(function() {
        var _this = this,
            index = jQuery(_this).index(),
            posLeft = jQuery(_this).parent().position().left,
            posWidth = jQuery(_this).parent().width(),
            width = (window.innerWidth > 0) ? window.innerWidth : screen.width,
            cssTop;


        jQuery('.methode-item').removeClass('active');
        jQuery(_this).addClass('active');


        /!*if (width > 991) {
            // Beschreibung eine Zeile tiefer anzeigen
            if (index < 3) {
                cssTop = jQuery(_this).offset().top + (jQuery(_this).height() + 30);
                jQuery(_this).children('.triangle').removeClass('top').addClass('bottom');
            }
            // Beschreibung eine Zeile höher anzeigen
            else {
                cssTop = jQuery(_this).offset().top - (jQuery('.methode-content:nth-child(' + (index+1) + ')').outerHeight() + 30);
                jQuery(_this).children('.triangle').removeClass('bottom').addClass('top');
            }
        }
        else if (width < 991 && width > 767) {
            if (index < 2) {
                cssTop = jQuery(_this).offset().top + (jQuery(_this).height() + 30);
                jQuery(_this).children('.triangle').removeClass('top').addClass('bottom');
            } else {
                cssTop = jQuery(_this).offset().top - (jQuery('.methode-content:nth-child(' + (index+1) + ')').outerHeight() + 30);
                jQuery(_this).children('.triangle').removeClass('bottom').addClass('top');
            }
        } else if (width < 768) {
            cssTop = jQuery(_this).offset().top - (jQuery('.methode-content:nth-child(' + (index+1) + ')').outerHeight() + 30);
            jQuery(_this).children('.triangle').removeClass('bottom').addClass('top');
        }*!/

        jQuery('.methode-content').hide();
        jQuery(_this).children('.triangle').css({
            left: (jQuery(_this).width() / 2) - 10
        }).show();

        jQuery('.methode-content:nth-child(' + (index+1) + ')').css({
            top: jQuery(_this).offset().top + (jQuery(_this).height() + 30),
            left: posLeft,
            width: (posWidth - 30)
        }).show();
    },
    function () {
        jQuery(this).children('.triangle').hide();
        jQuery('.methode-content').hide();
        jQuery(this).removeClass('active');
    });*/
    /*jQuery('.methode-item').on('click', function() {
        var _this = this;

        jQuery('.methode-item').removeClass('active');
        jQuery(this).addClass('active');

        jQuery('.methode-description').children().children().children('h2').text(
            jQuery(_this).children().children('.title').text()
        );
        jQuery('.methode-description').children().children().children('.description').html(
            jQuery(_this).children().children('.description').html()
        );
    });*/

    jQuery('#go-to-contact').on('click', function () {
        if (jQuery(this).attr('href') == '#kontakt') {
            jQuery("html, body").animate({ scrollTop: jQuery('#kontakt').offset().top }, 1000);
        }
    });
});

jQuery(window).on('resize', function () {
    if (jQuery('.infographic').length) {
        var info = new Infographic();
        info.init();
    }

    initSite();
});

function initSite () {
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

    /**
     * Ausrichtung der Skill-Buttons
     */

    if (width <= 991) {
        jQuery('.skill-item').css({
            height: 'auto'
        });
    } else {
        var skillHeight = 0;
        jQuery('.skill-item').each(function(index) {
            if (jQuery(this).outerHeight() > skillHeight) {
                skillHeight = jQuery(this).outerHeight();
            }
        }).promise().done(function () {
            jQuery('.skill-item').each(function(index) {
                jQuery(this).css({
                    height: skillHeight + 'px'
                });
            });
        });
    }
}
